import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Stats from '../components/Stats';
import Services from '../components/Services';
import Marquee from '../components/Marquee';
import Process from '../components/Process';
import MobileSection from '../components/MobileSection';
import CTA from '../components/CTA';
import Footer from '../components/Footer';
import CursorGlow from '../components/CursorGlow';
import BackgroundEffects from '../components/BackgroundEffects';
import useScrollReveal from '../hooks/useScrollReveal';
import SEO from '../components/SEO';
import '../styles/Hero.css';
import '../styles/Sections.css';

const HomePage = () => {
  useScrollReveal();

  return (
    <>
      <SEO 
        title="Inicio" 
        description="Agencia digital experta en materializar tus ideas con tecnología de vanguardia y diseño de alto impacto. Landing pages, eCommerce, apps móviles y software a medida."
        keywords="desarrollo web, agencia digital, apps móviles, landing pages, Guadalajara, software"
      />
      <CursorGlow />
      <BackgroundEffects />
      <Navbar />
      <Hero />
      {/* <Stats /> */}
      <Services />
      <Marquee />
      <Process />
      <MobileSection />
      <CTA />
      <Footer />
    </>
  );
};

export default HomePage;
